import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const prepareMswMocks = async (): Promise<void> => {
  const { startMocks } = await import('./mswDev');
  await startMocks();
};

const root = createRoot(document.getElementById('root')!);

if (import.meta.env.MODE === 'production') {
  root.render(<App />);
} else {
  // In development, we wait for the mocks to be ready before rendering the app.
  // If MSW setup fails, still render so the app isn't stuck on a blank screen.
  prepareMswMocks()
    .catch((error) => {
      console.error('Failed to start MSW mocks', error);
    })
    .finally(() => {
      root.render(<App />);
    });
}
